const config = {
  api: {
    live: 'https://www.delfi.lt/misc/pc/custom-pages/prezidento-rinkimai/feed.php',
    test: 'https://www.hamlet.delfi.lt/misc/pc/custom-pages/prezidento-rinkimai/feed.php',
  },
};
export default config;
